import React from 'react';
import DisplayAttr from './display-attr';

class DisplayGroup extends React.Component {
  constructor(props){
    super(props);
    this.renderLayerInfo = this.renderLayerInfo.bind(this);
  }
  renderLayerInfo(){
    const {title, children, subGroup} = this.props;
    let childArr = []
    let subGroupContent = null;
    if(children && children.length>0) {
      childArr =children.map((obj, idx) =>{
        return(<DisplayAttr key={idx} title={obj.title} value={obj.value}/>);
      })
    }else{
      childArr.push(
        <h6 key={`${title}-noAttributes`}>No Information Provided</h6>
      )
    }
    if(subGroup) {
      let subGrpChildArr =[]
      if(subGroup.children && subGroup.children.length>0) {
        subGrpChildArr=subGroup.children.map((obj, idx) =>{
          return(<DisplayAttr key={idx} title={obj.title} value={obj.value}/>);
        })
      }
      subGroupContent=(
        <>
          <h5><u>{subGroup.title}</u></h5>
          <div style={{display:'flex', flexDirection:'column', marginLeft:'24px'}}>
            {subGrpChildArr}
          </div>
        </>
      )
    }
    const content=(
      <>
        <h5><u>{title}</u></h5>
        <div style={{display:'flex', flexDirection:'column', marginLeft:'18px'}}>
          {childArr}
          {subGroupContent}
        </div>
      </>
    )
    return content;
  }
  
  
  render(){
    return (
      <div>
        {this.renderLayerInfo()} 
      </div>
    )
  }
}

export default DisplayGroup;
